import type {GetConsultPreviewRefundsParams} from 'domain/usecases';
import {getCurrentAccountAdapter} from 'main/adapters/current-account-adapter';
import {makeGetConsultPreviewRefunds} from 'main/factories/usecases';
import {UserTypeEnum} from 'presentation/constants';
import {getUserInfoFromToken} from 'presentation/utils';

export const getConsultPreviewRefund = async ({
	page,
	limit,
	startDate,
	endDate,
}: GetConsultPreviewRefundsParams) => {
	const {
		beneficiary: {tipoUsuarioC, cdUsuario},
	} = getCurrentAccountAdapter();

	const isHolder = tipoUsuarioC === UserTypeEnum.HOLDER;
	const userCode = getUserInfoFromToken().cdUsuario;

	const params = {
		userCode: cdUsuario,
		startDate: startDate || undefined,
		endDate: endDate || undefined,
		patientCode: isHolder ? undefined : userCode,
		limit,
		page,
	};

	const response = await makeGetConsultPreviewRefunds().get(params);

	if (!response) {
		return {
			items: [],
			total: 0,
			pages: 0,
		};
	}

	const pages = limit
		? Math.ceil(response.content.total / limit)
		: Math.ceil(response.content.total / response.content.totalPerPage);

	return {
		items: response?.content?.consultRefunds,
		total: response.content.total,
		pages,
	};
};
